import BigNumber from 'bignumber.js'

// 判断是否为移动端

export function CheckMobileDevice() {
    const userAgent = navigator.userAgent;
    const mobileAgents = ['Android', 'iPhone', 'Symbian', 'WindowsPhone', 'iPod', 'BlackBerry', 'Windows CE'];
    let is_mobile = false
    mobileAgents.map((value) => {
        if (userAgent.indexOf(value) > -1) {
            is_mobile = true
        }
    })
    return is_mobile
}


// 改变日期格式
export function changeDateFormat (dateTimeStr: any, timeType: 1) {
    // timeType:  1 - 返回年月日   2 - 返回日月年
    const date = new Date(dateTimeStr);

    // 获取日期和时间的各个部分
    const year = date.getFullYear();
    let month: number | string = date.getMonth() + 1; // 月份是从0开始的，所以需要加1
    let day: number | string = date.getDate();
    let hours: number | string = date.getHours();

    month = month > 9 ? month : '0'+month
    day = day > 9 ? day : '0'+day
    hours = hours > 9 ? hours : '0'+hours

    // 格式化日期和时间
    if(timeType == 1) {
        return `${year}/${month}/${day}`;
    }else {
        // 国外格式
        return `${month}/${day}/${year}`;
    }
    
}
export function isValidEmailSuffix(email: string) {
    // 正则表达式匹配常见的域名后缀
    const validSuffixRegex = /\.(com|net|org|edu|gov)$/i;

    // 提取邮箱地址中的域名后缀部分
    const suffix = email.split('@')[1];

    // 进行匹配
    return validSuffixRegex.test(suffix);
}
// 一维数组转换二维数组
export function toTwoDimensionalArray(arr: any[], length: number) {
    const result: any[] = [];
    for (let i = 0; i < arr.length; i += length) {
        result.push(arr.slice(i, i + length));
    }
    return result;
}

export function getNewTypeText(type: number) {
    if(type == 1) {
        return 'Board Game'
    }else {
        return 'Digital Game'
    }
}

// 判断富文本是否为空
export function stripHtml(html: string) {
    // 使用正则表达式移除 HTML 标签
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
}


//格式化金额 (分转元)
export function MoneyFormatYuan(value: number = 0): number {
    return Number(new BigNumber(value).dividedBy(100).toFixed(2).toString())
}
//格式化金额 (元转分)
export function MoneyFormatCent(value: number = 0): number {
    return Number(new BigNumber(value).multipliedBy(100).toFixed(2).toString())
}
// 🔧 转换 HEX -> RGB
export function hexToRgb  (hex: string) {
    hex = hex.replace('#', '')
    if (hex.length === 3) {
        hex = hex.split('').map(x => x + x).join('')
    }
    const bigint = parseInt(hex, 16)
    const r = (bigint >> 16) & 255
    const g = (bigint >> 8) & 255
    const b = bigint & 255
    return `${r}, ${g}, ${b}`
}

export function updateHashQueryParam(key, value) {
    const fullHash = window.location.hash // e.g. "#/page?foo=bar"
    const [path, queryString = ''] = fullHash.slice(1).split('?') // 移除 #

    const params = new URLSearchParams(queryString)
    params.set(key, value)

    const newHash = `#${path}?${params.toString()}`
    window.history.replaceState({}, '', newHash)
}